import { render, staticRenderFns } from "./Sukmaindera.vue?vue&type=template&id=dcb9fa84&scoped=true&"
import script from "./Sukmaindera.vue?vue&type=script&lang=js&"
export * from "./Sukmaindera.vue?vue&type=script&lang=js&"
import style0 from "./Sukmaindera.vue?vue&type=style&index=0&id=dcb9fa84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb9fa84",
  null
  
)

export default component.exports